<div class="tooltip-header-content">
  <div><ng-content></ng-content></div>
  <button mat-icon-button (click)="closeModal.emit(true)">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
